export const PageHeader = ({pageTitle}) => {
    return (
        <div className="h-52 bg-purple-950 flex items-center">
            <h1 className='text-white font-bold text-3xl' style={{margin: "0 var(--left-right-margin)"}}>{pageTitle}</h1>
        </div>
    )
    
}